import React from "react";
import ReactPlayer from "react-player/lazy";

import { Skeleton } from "../Skeleton";

import { VideoInterface } from "./types";

import "./styles.scss";

export const Video = (props: VideoInterface) => {
  const { width = "100%", height = "100%", url, onReady, onError } = props;
  const [isVideoOnReady, setIsVideoOnReady] = React.useState(false);

  if (!url) return;
  return (
    <div
      data-testid="Video"
      className={`player-wrapper ${isVideoOnReady ? "" : "player-wrapper--loading"}`}>
      {!isVideoOnReady && (
        <Skeleton
          width="100%"
          height="100%"
          style={{ position: "absolute", top: 0, left: 0 }}
          className="video-skeleton"
        />
      )}
      <ReactPlayer
        data-testid="ReactPlayer"
        className="react-player"
        url={url as any}
        onReady={(_player) => (onReady(true), setIsVideoOnReady(true))}
        controls
        config={{
          file: {
            forceVideo: true,
          },
        }}
        width={width}
        height={height}
        onError={(error) => {
          return (
            error?.type === "error" && (onReady(false), setIsVideoOnReady(false), onError(error))
          );
        }}
      />
    </div>
  );
};
